import { render, staticRenderFns } from "./FlightEditor.vue?vue&type=template&id=187c0162&scoped=true&"
import script from "./FlightEditor.vue?vue&type=script&lang=js&"
export * from "./FlightEditor.vue?vue&type=script&lang=js&"
import style0 from "./FlightEditor.vue?vue&type=style&index=0&id=187c0162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187c0162",
  null
  
)

export default component.exports